/**
 * QuantiyButton Component
 * expects a wrapper element
 * requires element to have three defined data elements
 * for increase and decrease buttons and the quantitiy input
 * Dispatches an event for use in cart
 **/
import eventBus from '../services/event-bus';
import elementExists from '../utils/element-exists';

const QuantityComponent = function (containerElement) {
	const defaults = { minValue: 0, maxValue: 1000 };
	let _this = {};
	let timeout = false;
	let data = containerElement.dataset;
	let quantityDec = containerElement.querySelector('[data-quantity-dec]');
	let quantityInc = containerElement.querySelector('[data-quantity-inc]');
	let quantityInput = containerElement.querySelector('[data-quantity-input]');
	let lastQuantity = quantityInput.value;

	data = Object.assign(defaults, data);

	const removeListeners = () => {
		// remove the listeners first
		// these may be added dynamically to the page
		quantityDec.removeEventListener('click', () => {});
		quantityInc.removeEventListener('click', () => {});
		quantityInput.removeEventListener('keyup', () => {});
	};

	const init = function () {
		removeListeners();

		quantityDec.addEventListener('click', function () {
			updateQuantity('dec');
		});

		quantityInc.addEventListener('click', function () {
			updateQuantity('inc');
		});

		quantityInput.addEventListener('keyup', function () {
      let val = parseInt(quantityInput.value);

      timeout = setTimeout(function () {
        eventBus.dispatch(eventBus.types.QuantityUpdated, {
          target: containerElement,
          value: val
        })
      }, 250)
    })
	};

	const updateQuantity = function (dir) {
		clearTimeout(timeout);

		let val = parseInt(quantityInput.value);

		if (dir == 'input') {
			if (isNaN(val)) {
				val = +data.minValue;
			}

			if (val < +data.minValue) {
				val = +data.minValue;
			}

			if (val > +data.maxValue) {
				val = +data.maxValue;
			}

			if (val <= +data.minValue) {
				quantityDec.setAttribute('disabled', true);
			} else {
				quantityDec.removeAttribute('disabled');
			}

			if (val >= +data.maxValue) {
				quantityInc.setAttribute('disabled', true);
			} else {
				quantityInc.removeAttribute('disabled');
			}
		}

		if (dir == 'dec') {
			if (val <= +data.minValue + 1) {
				quantityDec.setAttribute('disabled', true);
				if (val <= +data.minValue) {
					return;
				}
			}
			quantityInc.removeAttribute('disabled');
			val -= 1;
		}

		if (dir == 'inc') {
			if (val >= +data.maxValue - 1) {
				quantityInc.setAttribute('disabled', true);
				if (val >= +data.maxValue) {
					return;
				}
			}
			val += 1;
			quantityDec.removeAttribute('disabled');
		}

		quantityInput.value = val;
		lastQuantity = val;
		timeout = setTimeout(function () {
			eventBus.dispatch(eventBus.types.QuantityUpdated, {
				target: containerElement,
				value: val,
			});
		}, 250);
	};

	// call InitQuantityInput
	if (
		elementExists(quantityDec) &&
		elementExists(quantityInc) &&
		elementExists(quantityInput)
	) {
		init();
	}
};

export default QuantityComponent;
